import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0007bdc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "email" }

import { computed } from 'vue'
import { Contact, getContactDisplayName } from '@/manage/contacts/ContactProviders'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSearchItem',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;



const displayNameRef = computed(() => getContactDisplayName(props.item.contact) ?? props.item.value)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(displayNameRef.value), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.item.value), 1)
  ]))
}
}

})